import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { SceneFrame } from './_atoms';

const scenarios = [
  { allowed: true,  text: 'User in multiple entities under one organization',  cond: 'Same category across the org' },
  { allowed: true,  text: 'User in multiple standalone entities',              cond: 'All share the same entity category' },
  { allowed: true,  text: 'User holds different roles across entities',         cond: 'Roles drawn from the category catalog' },
  { allowed: true,  text: 'User in org entities + standalone entities',       cond: 'Standalone category matches org category' },
  { allowed: false, text: 'User across entities of different categories',       cond: 'Category mismatch — business logic conflict' },
  { allowed: false, text: 'Regulator/Owner mixed with standard categories',       cond: 'Cross-entity visibility conflict' },
];

export default function ArchScenariosScene() {
  return (
    <SceneFrame
      eyebrow="Assignment scenarios"
      title="What's permitted · what isn't"
      subtitle="The same-category rule is the linchpin of the Eclaims model. It prevents context conflicts and guarantees every access decision flows through a predictable path."
    >
      <motion.div
        initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
        className="rounded-2xl bg-white border border-[#E5E7EB] overflow-hidden shadow-sm"
      >
        <div className="grid grid-cols-[80px_1fr_1fr] gap-0 bg-[#FAFAFA] border-b border-[#E5E7EB] px-6 py-3">
          <span className="text-[11px] font-body font-bold text-[#374151] uppercase tracking-wider">Permitted</span>
          <span className="text-[11px] font-body font-bold text-[#374151] uppercase tracking-wider">Scenario</span>
          <span className="text-[11px] font-body font-bold text-[#374151] uppercase tracking-wider">Condition</span>
        </div>

        {scenarios.map((s, i) => (
          <motion.div
            key={s.text}
            initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 + i * 0.12 }}
            className={`grid grid-cols-[80px_1fr_1fr] gap-0 px-6 py-4 border-b border-[#F3F4F6] last:border-0 items-center ${
              s.allowed ? '' : 'bg-rose-50/40'
            }`}
          >
            <div>
              {s.allowed ? (
                <motion.div
                  initial={{ scale: 0 }} animate={{ scale: 1 }}
                  transition={{ delay: 0.6 + i * 0.12, type: 'spring', stiffness: 320 }}
                  className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center shadow-sm shadow-emerald-500/30"
                >
                  <Check size={14} className="text-white" strokeWidth={3} />
                </motion.div>
              ) : (
                <motion.div
                  initial={{ scale: 0 }} animate={{ scale: 1 }}
                  transition={{ delay: 0.6 + i * 0.12, type: 'spring', stiffness: 320 }}
                  className="w-7 h-7 rounded-full bg-rose-500 flex items-center justify-center shadow-sm shadow-rose-500/30"
                >
                  <X size={14} className="text-white" strokeWidth={3} />
                </motion.div>
              )}
            </div>
            <div className="font-body text-[13px] text-[#0A0A0A] font-medium leading-snug">{s.text}</div>
            <div className={`font-body text-[12px] leading-snug ${s.allowed ? 'text-[#6B7280]' : 'text-rose-700'}`}>{s.cond}</div>
          </motion.div>
        ))}
      </motion.div>
    </SceneFrame>
  );
}
